
import React, { useState, useEffect } from 'react';
import { Table, Select, Badge, message, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import './MyRequests.css';

const { Option } = Select;

const MyRequests = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();

  const fetchTickets = async () => {
    setLoading(true);
    try {
      console.log('Récupération des tickets depuis /Backend/admin_get_tickets.php');
      const response = await fetch('/Backend/admin_get_tickets.php', {
        method: 'GET',
        credentials: 'include',
      });
      console.log('Statut HTTP:', response.status);
      const text = await response.text();
      console.log('Réponse brute:', text);
      let data;
      try {
        data = JSON.parse(text);
        console.log('Réponse:', data);
      } catch (e) {
        console.error('Erreur de parsing JSON:', e, 'Texte reçu:', text);
        throw new Error('Réponse non-JSON reçue du serveur.');
      }

      if (response.ok) {
        const formattedTickets = data.tickets.map((ticket) => ({
          key: ticket.id,
          date: new Date(ticket.date).toLocaleDateString('fr-FR'), // Format DD/MM/YYYY
          issue: ticket.issue,
          status: ticket.status,
          email: ticket.admin_email,
        }));
        setTickets(formattedTickets);
      } else {
        if (response.status === 403) {
          message.error('Session expirée. Veuillez vous reconnecter.', 5);
          navigate('/adminlogin');
        } else {
          message.error(data.error || 'Erreur lors de la récupération des tickets.', 5);
        }
      }
    } catch (error) {
      console.error('Erreur réseau:', error.message);
      message.error(`Erreur réseau: ${error.message}`, 5);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Issue',
      dataIndex: 'issue',
      key: 'issue',
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (status) => {
        let color, backgroundColor;
        switch (status) {
          case 'Pending':
            color = '#000';
            backgroundColor = '#ffec3d';
            break;
          case 'Admin Responded':
            color = '#fff';
            backgroundColor = '#52c41a';
            break;
          case 'Closed':
            color = '#fff';
            backgroundColor = '#ff4d4f';
            break;
          case 'Resolved':
            color = '#fff';
            backgroundColor = '#1890ff';
            break;
          default:
            color = '#000';
            backgroundColor = '#fff';
        }
        return (
          <Badge
            count={status}
            style={{
              backgroundColor,
              color,
              padding: '4px 12px',
              borderRadius: '12px',
              fontSize: '12px',
            }}
          />
        );
      },
    },
  ];

  return (
    <div className="my-requests-container">
      <div className="table-header">
        <Select
          defaultValue="10"
          style={{ width: 100 }}
          onChange={(value) => setPageSize(Number(value))}
        >
          <Option value="10">10</Option>
          <Option value="20">20</Option>
          <Option value="50">50</Option>
        </Select>
        <span>entries</span>
      </div>
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={tickets}
          pagination={{ pageSize }}
          className="table-style"
          rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-even' : 'table-row-odd')}
        />
      </Spin>
    </div>
  );
};

export default MyRequests;
